import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './config/firebase';
import { GameProvider, useGame } from './context/GameContext';
import { PlayerProvider, usePlayer } from './context/PlayerContext';
import { useGameState } from './hooks/useGameState';
import HomeScreen from './components/screens/HomeScreen';
import LobbyScreen from './components/screens/LobbyScreen';
import GameBoardScreen from './components/screens/GameBoardScreen';
import RoundEndScreen from './components/screens/RoundEndScreen';
import GameOverScreen from './components/screens/GameOverScreen';
import { PHASES } from './utils/gameRules';
import './styles/variables.css';
import './styles/board.css';
import './styles/cards.css';

function GameRouter() {
  const { state } = useGame();
  const { playerId } = usePlayer();
  useGameState();

  const { roomCode, gameState } = state;

  if (!roomCode || !playerId) {
    return <HomeScreen />;
  }

  switch (gameState.phase) {
    case PHASES.LOBBY:
      return <LobbyScreen />;
    case PHASES.DEALING:
    case PHASES.REVEALING:
    case PHASES.PLAYING:
    case PHASES.ROUND_END_PHASE:
      return <GameBoardScreen />;
    case PHASES.ROUND_END:
      return <RoundEndScreen />;
    case PHASES.GAME_OVER:
      return <GameOverScreen />;
    default:
      return <HomeScreen />;
  }
}

function AuthGate({ children }) {
  const [ready, setReady] = useState(false);
  const { setPlayerId } = usePlayer();
  const setPlayerIdRef = React.useRef(setPlayerId);
  setPlayerIdRef.current = setPlayerId;

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        setPlayerIdRef.current(user.uid);
      }
      setReady(true);
    });
    return unsub;
  }, []);

  if (!ready) {
    return (
      <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ color: '#a0c0a8' }}>Shuffling the deck...</span>
      </div>
    );
  }

  return children;
}

function App() {
  return (
    <GameProvider>
      <PlayerProvider>
        <AuthGate>
          <div className="app">
            <GameRouter />
          </div>
        </AuthGate>
      </PlayerProvider>
    </GameProvider>
  );
}

export default App;
